export const examAdminPaperEditor = {
  pickTableCode: "题目编号",
  pickTablePreview: "预览",
  pickTableAdd: "加入",
  pickTableTitle: "题目",
  pickTableKeywordPlaceholder: "按题目编号/标题/题型搜索",
  pickTableKnowledgePoints: "知识点 / 标签",
  pickTableDifficulty: "难度",
  pickTableUpdatedAt: "修改时间",
  pickNoSelection: "未选择可加入的题目",
  pickAlreadyIncluded: "已选 {count} 题均已在清单中",
  pickAddedSuccess: "已加入 {count} 题到试卷清单",
  ruleNoQuestions: "规则筛选后没有可用题目",
  rulePickedSuccess: "已按规则自动选入 {count} 题",
  typeScoreInvalid: "题型分值必须为非负数",
  typeScoreApplied: "已将 {type} 题型分值统一为 {score}",
  typeRemoved: "已移除 {type} 题型的 {count} 道题",
  poolTotal: "题库总数：{count}",
  poolPublished: "已发布：{count}",
  poolSelectable: "可加入：{count}",
  poolSelected: "已选：{count}",
  poolFiltered: "当前筛选：{count}",
  batchAddSelected: "批量加入已选（{count}）",
  selectedFirstOn: "已选置顶",
  selectedFirstOff: "普通排序",
  deduplicateHint: "已加入题目会自动去重跳过。",
  typeTabAll: "全部（{count}）",
  selectedQuestionsCount: "已加入题目 {count} 题",
  currentTotalScore: "当前总分 {score}",
  selectedTypeCount: "题型数 {count}",
  targetTotalScore: "目标总分 100：{status}",
  targetTotalScoreAligned: "已对齐",
  targetTotalScoreDifference: "当前差值 {value}",
  selectedAdjustHint: "先在题型管理里统一分值和顺序，再在下方微调单题。",
  bulkScorePlaceholder: "批量分值",
  bulkUpdateScore: "批量改分（{count}）",
  bulkDelete: "批量删除（{count}）",
  typeManagementTitle: "题型管理（拖拽排序 + 每题分值）",
  typeQuestionCount: "{count} 题",
  applyPerQuestionScore: "应用每题分值",
  removeType: "移除该题型",
  groupedTypeSummary: "{label}（{count}）总分 {score}",
  moveUp: "上移",
  moveDown: "下移",
  itemScore: "分值",
  removeItem: "删除",
  latestVersionLabel: "{code} · {title}（最新版本）",
  latestVersionFallback: "最新版本",
  itemNoteToggle: "备注（可选）",
  itemNotePlaceholder: "记录该题在本试卷中的特殊说明",
  formTitle: "试卷名称",
  formPaperType: "卷型",
  formDescription: "试卷说明",
  formTotalScore: "总分（自动汇总）",
  formDuration: "建议时长（分钟）",
  ruleSectionTitle: "组卷规则",
  ruleSectionHint: "使用可视化规则配置生成 rule_json，不再要求手填 JSON。",
  rulePreset: "规则预设",
  rulePresetManual: "手工优先",
  rulePresetBalanced: "均衡组卷",
  rulePresetKnowledge: "知识点优先",
  rulePresetDifficulty: "难度优先",
  ruleTargetDifficulty: "目标难度",
  ruleAvoidPreviousExam: "避免重复上一场考试",
  switchOn: "开启",
  switchOff: "关闭",
  ruleQuestionTypes: "题型范围",
  ruleQuestionTypesPlaceholder: "限制试卷题型范围",
  ruleKnowledgePoints: "知识点范围",
  ruleKnowledgePointsPlaceholder: "选择知识点范围",
  ruleTags: "标签范围",
  ruleTagsPlaceholder: "选择标签范围",
  ruleNotes: "规则备注",
  ruleNotesPlaceholder: "记录本次组卷意图或特殊限制",
  autoPickCountLabel: "自动选题数量",
  autoPickCountPlaceholder: "题数",
  autoPickCountUnit: "题",
  ruleAutoPick: "按规则自动选题",
  ruleAutoPickHint: "仅从已发布题目中按规则筛选并替换当前清单。",
  ruleGeneratedHint:
    "差分試験用紙はルールで生成されるため、この段階では手動で問題を選びません。ルールと目標総点を設定すると、後で受験者ごとに差分問題が生成されます。",
  questionPoolTitle: "题库池",
  selectedListTitle: "已选清单",
  batchPickTitle: "批量选题",
  questionListTitle: "题目清单",
  jsonPreviewTitle: "结构化 JSON 预览",
  jsonPreviewExpand: "展开查看结构化 JSON 预览",
  jsonPreviewHint:
    "当前表单会自动生成 rule_json 和每题 item_config_json，JSON 仅用于预览和核对。",
  previewModalTitle: "{code} 题目预览",
  previewModalFallbackTitle: "题目预览",
} as const;
